import { FREIGHT_TERMS_OPTIONS } from "@/constants/freighTerms"
import type { FreightTerms } from "@/graphql/codegen/graphql"

export const getFreightTermLabel = (term: FreightTerms | null | undefined): string | null => {
  if (!term) return null

  const option = FREIGHT_TERMS_OPTIONS.find((opt) => opt.value === term)
  return option?.label ?? null
}
